import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ModeToggle"] */ "/app/src/components/shell/mode-toggle.tsx");
